import { useLocation, useParams } from 'react-router-dom';
import queryString from 'query-string';
/**
 * 获取参数
 * @param key {string}
 * @returns
 */
export function useRouteQuery(key) {
  const location = useLocation();
  const _params: any = new URLSearchParams(location.search);
  const value = _params.get(key) || '';
  return value;
}

export function useRouteParams(key) {
  return useParams()?.[key];
}

export function useAllRouteQuery() {
  const location = useLocation();
  const queryParams = queryString.parse(location.search);
  return queryParams;
}
